// @ts-nocheck
import { useState } from 'react';
import { Dialog, Button, TextField } from '@workspace/design-system/src/components';

interface CancelWithReasonDialogProps {
  title: string;
  channelName?: string;
  description?: string;
  showWarning?: boolean;
  warningText?: string;
  reasonPlaceholder?: string;
  confirmButtonText?: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

/**
 * 취소 사유를 입력받는 공통 다이얼로그
 * cancel-plan-dialog와 payment-cancel-form-dialog를 통합
 */
export function CancelWithReasonDialog({
  title,
  channelName,
  description,
  showWarning = true,
  warningText = '※ 취소 후에는 복구할 수 없습니다.',
  reasonPlaceholder = '취소 사유를 입력해 주세요.',
  confirmButtonText = '확인',
  isLoading = false,
  onClose,
  onConfirm,
}: CancelWithReasonDialogProps) {
  const [cancelReason, setCancelReason] = useState('');

  const handleConfirm = () => {
    if (cancelReason.trim()) {
      onConfirm(cancelReason);
    }
  };

  return (
    <Dialog>
      <Dialog.Content>
        <Dialog.Header title={title} type="destructive" showIcon />

        <Dialog.Body>
          <div className="flex flex-col gap-4">
            {channelName && (
              <p className="text-[14px] text-[#101010] leading-[20px] tracking-[-0.1px]">
                {channelName}
              </p>
            )}
            
            {description && (
              <div className="self-stretch justify-center">
                <p className="text-text-text-default text-sm font-normal font-['Pretendard'] leading-5 whitespace-pre-line">
                  {description}
                </p>
              </div>
            )}

            {showWarning && (
              <span className="text-sm font-normal font-['Pretendard'] leading-5 text-[#D15445]">
                {warningText}
              </span>
            )}

            <div className="flex flex-col gap-2">
              <TextField
                value={cancelReason}
                onChange={(value) => setCancelReason(value)}
                placeholder={reasonPlaceholder}
              />
            </div>
          </div>
        </Dialog.Body>

        <Dialog.Footer>
          <Button type="button" onClick={onClose}>
            닫기
          </Button>
          <Button
            type="button"
            styleType="destructive"
            disabled={!cancelReason.trim() || isLoading}
            isLoading={isLoading}
            onClick={handleConfirm}
          >
            {confirmButtonText}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}

